export default {"src":"/_next/static/media/notification.7276c184.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};